import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Grid, Row, Col } from 'react-bootstrap'
import { fetchData } from '../../common/redux/collectionActions'
import "../Cluster/cluster.css"
import UnallocatedDoor from "./UnallocatedDoor"
import AllocatedDoor from "./AllocatedDoor"

class ClusterDoors extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: -1
        }

        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
    }

    openModal = id => {
        this.setState({ modalIsOpen: id })
    }

    closeModal() {
        this.setState({ modalIsOpen: -1 })
    }

    render() {
        const { lock } = this.props

        if (!lock.doors) return null

        return (
            <div>
                <Grid style={{ marginTop: "20px", marginBottom: "20px" }} className="component-width">
                    <Row>
                        {lock.doors.map((door, i) => {
                            let comp
                            if (Object.values(door.allocation).filter(v => v).length > 0) {
                                comp = <AllocatedDoor key={i} door={door} lock={lock} closeModal={() => this.closeModal()} isOpen={this.state.modalIsOpen === door._id} />
                            } else {
                                comp = <UnallocatedDoor key={i} door={door} lock={lock} />
                            }

                            return <Col key={door.id} style={{ marginBottom: "50px" }} xs={12} md={3}>{comp}</Col>
                        })}
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        fetchData: (params) => dispatch(fetchData(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClusterDoors)
